import React from 'react';
import { useDateRange } from '../../contexts/DateRangeContext';
import { useSaasVendor } from '../../contexts/SaasVendorContext';
import { AtlasTimeRangeScope } from '../../pages/agent-atlas/hooks/AtlasTimeRangeScope';
import { SaasEntityScopeProvider } from './SaasEntityScope';

/**
 * Atlas pages mounted under /saas-ai read the AI Providers module's own date
 * window (the DateRangeProvider around the module's routes, shared by every
 * AI Providers page) rather than the app-wide Atlas one, so a page drawn by
 * Atlas agrees with the module's other pages and never moves Atlas' own
 * window. The same arrangement Gemini Enterprise uses (GeminiAgentsLayout).
 *
 * It also holds the module's agent / user selection (SaasEntityScope), one per
 * vendor: remounted on a vendor switch, so one provider's agents never scope
 * another's.
 */
const SaasAtlasWindow = ({ children }) => {
  const { dateRange, dateParams, handleDateChange } = useDateRange();
  const { vendor } = useSaasVendor();
  return (
    <AtlasTimeRangeScope rangeKey={dateRange} dateRange={dateParams} setRange={handleDateChange}>
      <SaasEntityScopeProvider vendor={vendor}>
        {children}
      </SaasEntityScopeProvider>
    </AtlasTimeRangeScope>
  );
};

export default SaasAtlasWindow;
